import { DishOrderPortions } from "client/jspPlatformExperiment";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import merge from "lodash-es/merge";
import { v4 as uuidv4 } from "uuid";

interface DisplayDishOrderPortions extends Omit<DishOrderPortions, "food_id"> {
  food_id?: number;
}

export type TypeDisplayPortionOrders = Record<string, DisplayDishOrderPortions>;

interface DishPortionOrdersStateProps {
  dishPortionOrders: TypeDisplayPortionOrders;
  isLoading: boolean;
  error: string | null;
}

const initialState: DishPortionOrdersStateProps = {
  dishPortionOrders: { [uuidv4()]: { amount: 0 }, [uuidv4()]: { amount: 0 } },
  isLoading: false,
  error: null,
};

const updateADishPortionOrder = (
  state: DishPortionOrdersStateProps,
  action: PayloadAction<{
    entityUUID: string;
    dishPortionOrder: Partial<DisplayDishOrderPortions>;
  } | null>,
): DishPortionOrdersStateProps => {
  const newPortionOrders = action.payload
    ? merge({}, state.dishPortionOrders, {
        ...state.dishPortionOrders,
        [action.payload.entityUUID]: action.payload.dishPortionOrder,
      })
    : state.dishPortionOrders;
  return {
    ...state,
    dishPortionOrders: newPortionOrders,
  };
};

const deleteADishPortionOrder = (
  state: DishPortionOrdersStateProps,
  action: PayloadAction<{
    entityUUID: string;
  }>,
): DishPortionOrdersStateProps => {
  const { [action.payload?.entityUUID]: toDelete, ...newPortionOrders } =
    state.dishPortionOrders;
  return {
    ...state,
    dishPortionOrders: newPortionOrders,
  };
};

const appendADishPortionOrder = (
  state: DishPortionOrdersStateProps,
): DishPortionOrdersStateProps => ({
  ...state,
  dishPortionOrders: {
    ...state.dishPortionOrders,
    [uuidv4()]: { amount: 0 },
  },
});

const replaceDishPortionOrders = (
  state: DishPortionOrdersStateProps,
  action: PayloadAction<{
    newDishPortionOrders: DishOrderPortions[];
  } | null>,
): DishPortionOrdersStateProps => ({
  ...state,
  dishPortionOrders:
    action.payload?.newDishPortionOrders.reduce<TypeDisplayPortionOrders>(
      (acc, dishOrder) => {
        acc[uuidv4()] = dishOrder;
        return acc;
      },
      {},
    ) ?? {},
});

export const dishPortionOrdersSlice = createSlice({
  name: "dishPortionOrdersSlice",
  initialState,
  reducers: {
    setDishPortionOrders: updateADishPortionOrder,
    appendDishPortionOrder: appendADishPortionOrder,
    deleteDishPortionOrder: deleteADishPortionOrder,
    replaceDishPortionOrders,
  },
});

export const actions = {
  ...dishPortionOrdersSlice.actions,
};

export const dishPortionOrdersReducer = dishPortionOrdersSlice.reducer;

export default dishPortionOrdersReducer;
